import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Ruta`, method: 'GET', body: null, token: token})
}
